import api from './api';

export const anonymousService = {
  getAnonymousVisitors: async (projectId) => {
    const response = await api.get('/anonymous', { params: { project: projectId } });
    return response.data;
  },

  getAnonymousVisitor: async (id) => {
    const response = await api.get(`/anonymous/${id}`);
    return response.data;
  },

  deleteAnonymousVisitor: async (id) => {
    // In case there's ever a need to clear visitors
    const response = await api.delete(`/anonymous/${id}`);
    return response.data;
  }
};
